// // import React from "react";
// // import "./StickyHubButton.css";

// // /* ------------------------------------------------------------------
// //    HOW TO USE
// //    1. Change ACTIVE_THEME (1 to 7) to pick the design you like.
// //    2. SHOW_ALL_FOR_PREVIEW = true shows all 7 designs in a small panel
// //       so you can compare them. Set it to false when you have decided.
// // ------------------------------------------------------------------- */
// // const ACTIVE_THEME = 1;
// // const SHOW_ALL_FOR_PREVIEW = true;

// // // TODO: put the real Axis Business Hub link here
// // const HUB_URL = "https://your-axis-business-hub-link.com";
// // const HUB_LABEL = "Axis Business Hub";

// // /* 7 gradient themes based on the ASSOCHAM navbar colors
// //    bg     -> gradient background
// //    fg     -> text / icon color
// //    border -> border style
// //    glow   -> RGB used for the glow shadow
// //    radius -> corner roundness */
// // const THEMES = [
// // //   {
// // //     // 1) ASSOCHAM Red
// // //     id: 1,
// // //     // name: "ASSOCHAM Red",
// // //     bg: "linear-gradient(135deg, #e11d2a 0%, #b4121d 55%, #7f0d15 100%)",
// // //     fg: "#ffffff",
// // //     border: "1.5px solid rgba(255,255,255,0.4)",
// // //     glow: "225, 29, 42",
// // //     radius: "999px",
// // //   },
// // //   {
// // //     // 2) Sunset Orange (same family as "Become a Member")
// // //     id: 2,
// // //     name: "Sunset Orange",
// // //     bg: "linear-gradient(135deg, #fbbf24 0%, #f59e0b 50%, #ea580c 100%)",
// // //     fg: "#ffffff",
// // //     border: "1.5px solid rgba(255,255,255,0.5)",
// // //     glow: "245, 158, 11",
// // //     radius: "999px",
// // //   },
// //   {
// //     // 3) Fire Blend (red to orange)
// //     id: 3,
// //     name: "Fire Blend",
// //     bg: "linear-gradient(135deg, #dc2127 0%, #f0562a 50%, #f59e0b 100%)",
// //     fg: "#ffffff",
// //     border: "1.5px solid rgba(255,255,255,0.45)",
// //     glow: "240, 86, 42",
// //     radius: "999px",
// //   },
// // //   {
// // //     // 4) Dark Premium with gold border
// // //     id: 4,
// // //     name: "Dark Gold",
// // //     bg: "linear-gradient(135deg, #1c1c1c 0%, #3b0d10 60%, #5a1218 100%)",
// // //     fg: "#fcd34d",
// // //     border: "1.5px solid #d4a017",
// // //     glow: "212, 160, 23",
// // //     radius: "8px",
// // //   },
// // //   {
// // //     // 5) White with gradient border (red to orange)
// // //     id: 5,
// // //     name: "White Border",
// // //     bg: "linear-gradient(#ffffff, #ffffff) padding-box, linear-gradient(135deg, #dc2127, #f59e0b) border-box",
// // //     fg: "#c8161f",
// // //     border: "2px solid transparent",
// // //     glow: "220, 33, 39",
// // //     radius: "999px",
// // //   },
// // //   {
// // //     // 6) Royal Navy to Red
// // //     id: 6,
// // //     name: "Navy to Red",
// // //     bg: "linear-gradient(135deg, #1e3a8a 0%, #7b1d5a 55%, #dc2127 100%)",
// // //     fg: "#ffffff",
// // //     border: "1.5px solid rgba(255,255,255,0.4)",
// // //     glow: "123, 29, 90",
// // //     radius: "8px",
// // //   },
// // //   {
// // //     // 7) Gold Shine
// // //     id: 7,
// // //     name: "Gold Shine",
// // //     bg: "linear-gradient(135deg, #fde68a 0%, #fbbf24 45%, #d97706 100%)",
// // //     fg: "#3b0d10",
// // //     border: "1.5px solid rgba(255,255,255,0.65)",
// // //     glow: "251, 191, 36",
// // //     radius: "999px",
// // //   },
// // ];

// // /* Small building icon (inline SVG) */
// // const HubIcon = () => (
// //   <svg
// //     width="14"
// //     height="14"
// //     viewBox="0 0 24 24"
// //     fill="none"
// //     stroke="currentColor"
// //     strokeWidth="2.2"
// //     strokeLinecap="round"
// //     strokeLinejoin="round"
// //     aria-hidden="true"
// //   >
// //     <path d="M3 21h18" />
// //     <path d="M5 21V7l7-4 7 4v14" />
// //     <path d="M9 21v-6h6v6" />
// //   </svg>
// // );

// // function HubButton({ theme, preview = false }) {
// //   const style = {
// //     "--hub-bg": theme.bg,
// //     "--hub-fg": theme.fg,
// //     "--hub-border": theme.border,
// //     "--hub-glow": theme.glow,
// //     "--hub-radius": theme.radius,
// //   };

// //   return (
// //     <a
// //       href={HUB_URL}
// //       target="_blank"
// //       rel="noopener noreferrer"
// //       aria-label={HUB_LABEL}
// //       className={`hub-btn ${preview ? "hub-preview" : ""}`}
// //       style={style}
// //     >
// //       <HubIcon />
// //       <span>{HUB_LABEL}</span>
// //     </a>
// //   );
// // }

// // export default function StickyHubButton() {
// //   // Preview mode: all 7 designs in one small panel
// //   if (SHOW_ALL_FOR_PREVIEW) {
// //     return (
// //       <div className="hub-preview-wrap">
// //         {THEMES.map((t) => (
// //           <div className="hub-preview-row" key={t.id}>
// //             {/* <span className="hub-preview-label">
// //               #{t.id} {t.name}
// //             </span> */}
// //             <HubButton theme={t} preview />
// //           </div>
// //         ))}
// //       </div>
// //     );
// //   }

// //   const active = THEMES.find((t) => t.id === ACTIVE_THEME) || THEMES[0];
// //   return <HubButton theme={active} />;
// // }





// // new code 





// import React from "react";

// /* ------------------------------------------------------------------
//    HOW TO USE
//    PREVIEW_MODE:
//      "designs" -> one row per color/shape pair (default)
//      "colors"  -> all colors using ACTIVE_STYLE
//      "styles"  -> all shapes using ACTIVE_COLOR
//      "off"     -> only the final button (production)
//    For the final choice set ACTIVE_COLOR and ACTIVE_STYLE,
//    then set PREVIEW_MODE = "off". Colors and shapes can be mixed freely.
//    Royal Purple (#7) and Axis Burgundy (#8) have a moving border animation.

//    AXIS BANNER (#8) is built ONLY with clip-path (no ::before / ::after
//    for the white part). The proportions follow the Axis Bank banner:
//    a flat top edge, a rounded corner, then a slanted edge going down
//    to the right. The glow is drawn by a wrapper (drop-shadow), because
//    a clip-path would cut away a normal box-shadow.
//    Tune the cut with --cut-h, --cut-flat and --cut-end in the CSS below.
//    NOTE: all CSS is inside this file, no separate .css file needed.
// ------------------------------------------------------------------- */
// const PREVIEW_MODE = "designs"; // "designs" | "colors" | "styles" | "off"
// const ACTIVE_COLOR = 8;
// const ACTIVE_STYLE = 8;

// // TODO: put the real Axis Business Hub link here
// const HUB_URL = "https://your-axis-business-hub-link.com";
// const HUB_LABEL = "Axis Business Hub";

// /* COLOR THEMES (all gradients)
//    bg     -> gradient background
//    fg     -> text / icon / border color
//    glow   -> RGB used for glow shadow and rings
//    moving -> (optional) true = moving border animation
//    trail  -> (optional) 3 colors of the moving light [start, middle, bright] */
// const COLORS = [
// //   {
// //     id: 1,
// //     name: "ASSOCHAM Red",
// //     bg: "linear-gradient(135deg, #e11d2a 0%, #b4121d 55%, #7f0d15 100%)",
// //     fg: "#ffffff",
// //     glow: "225, 29, 42",
// //   },
// //   {
// //     id: 2,
// //     name: "Sunset Orange",
// //     bg: "linear-gradient(135deg, #fbbf24 0%, #f59e0b 50%, #ea580c 100%)",
// //     fg: "#ffffff",
// //     glow: "245, 158, 11",
// //   },
// //   {
// //     id: 3,
// //     name: "Fire Blend",
// //     bg: "linear-gradient(135deg, #dc2127 0%, #f0562a 50%, #f59e0b 100%)",
// //     fg: "#ffffff",
// //     glow: "240, 86, 42",
// //   },
// //   {
// //     id: 4,
// //     name: "Dark Gold",
// //     bg: "linear-gradient(135deg, #111111 0%, #2b2b2b 55%, #4a3a12 100%)",
// //     fg: "#fcd34d",
// //     glow: "212, 160, 23",
// //   },
//   {
//     id: 5,
//     name: "Royal Navy",
//     bg: "linear-gradient(135deg, #0f2a6b 0%, #1d4ed8 55%, #38bdf8 100%)",
//     fg: "#ffffff",
//     glow: "29, 78, 216",
//   },
// //   {
// //     id: 6,
// //     name: "Emerald",
// //     bg: "linear-gradient(135deg, #065f46 0%, #059669 55%, #34d399 100%)",
// //     fg: "#ffffff",
// //     glow: "5, 150, 105",
// //   },
// //   {
// //     // Purple with the moving border animation (purple / pink light)
// //     id: 7,
// //     name: "Royal Purple",
// //     bg: "linear-gradient(135deg, #4c1d95 0%, #9333ea 55%, #ec4899 100%)",
// //     fg: "#ffffff",
// //     glow: "147, 51, 234",
// //     moving: true,
// //     trail: ["#c084fc", "#f472b6", "#ffffff"],
// //   },
// //   {
// //     // Axis Bank burgundy / magenta with the moving border animation
// //     id: 8,
// //     name: "Axis Burgundy",
// //     bg: "linear-gradient(135deg, #a3175a 0%, #97144d 50%, #7a0f3f 100%)",
// //     fg: "#ffffff",
// //     glow: "151, 20, 77",
// //     moving: true,
// //     trail: ["#e11d74", "#ff8fc0", "#ffffff"],
// //   },
// ];

// /* SHAPES (CSS for each one is in HUB_CSS below) */
// const STYLES = [
// //   { id: 1, name: "Round Pill" },
// //   { id: 2, name: "Square Box" },
// //   { id: 3, name: "Double Border" },
// //   { id: 4, name: "Dashed Border" },
//   { id: 5, name: "Arrow Tag" },
// //   { id: 6, name: "Hexagon" },
// //   { id: 7, name: "Cut Corner" },
// //   { id: 8, name: "Axis Banner" },
// ];

// /* All CSS lives here so there is no mismatch with an old .css file.
//    !important is used on shape/border props so global site CSS
//    cannot override the design. */
// const HUB_CSS = `
// /* animatable angle used by the moving border */
// @property --hub-angle{
//   syntax:'<angle>';
//   initial-value:0deg;
//   inherits:false;
// }

// .hub-btn{
//   position:fixed; left:16px; bottom:18px; z-index:999;
//   display:inline-flex !important; align-items:center; gap:6px;
//   width:auto !important; flex:0 0 auto;
//   padding:7px 14px; margin:0;
//   background:var(--hub-bg); color:var(--hub-fg) !important;
//   border:2px solid transparent;
//   border-radius:999px !important;
//   font-family:inherit; font-size:12px; font-weight:700; line-height:1;
//   letter-spacing:.3px; text-decoration:none !important; white-space:nowrap;
//   overflow:hidden; cursor:pointer;
//   box-shadow:0 4px 12px rgba(var(--hub-glow),.45);
//   transition:transform .25s ease, box-shadow .25s ease;
//   animation:hubPulse 2.6s ease-in-out infinite;
// }
// .hub-btn:hover{ transform:translateY(-2px); }

// /* shine sweep */
// .hub-btn::after{
//   content:""; position:absolute; top:0; left:-75%; width:50%; height:100%;
//   background:linear-gradient(120deg,transparent,rgba(255,255,255,.5),transparent);
//   transform:skewX(-20deg); animation:hubShine 3.4s ease-in-out infinite;
//   pointer-events:none;
// }
// @keyframes hubPulse{
//   0%,100%{ box-shadow:0 4px 12px rgba(var(--hub-glow),.4),0 0 0 0 rgba(var(--hub-glow),.4); }
//   50%{ box-shadow:0 4px 12px rgba(var(--hub-glow),.5),0 0 0 7px rgba(var(--hub-glow),0); }
// }
// @keyframes hubShine{ 0%{left:-75%} 55%,100%{left:130%} }

// /* ---------- SHAPES ---------- */

// /* 1) Round Pill: fully rounded, light border, soft glow */
// .hub-btn.hub-s1{
//   border-radius:999px !important;
//   border:2px solid rgba(255,255,255,.7) !important;
// }

// /* 2) Square Box: sharp corners, solid border, hard offset shadow */
// .hub-btn.hub-s2{
//   border-radius:0 !important;
//   border:2px solid var(--hub-fg) !important;
//   animation:none;
//   box-shadow:4px 4px 0 rgba(0,0,0,.4);
// }

// /* 3) Double Border: inner border + outer ring */
// .hub-btn.hub-s3{
//   border-radius:12px !important;
//   border:2px solid var(--hub-fg) !important;
//   outline:2px solid rgb(var(--hub-glow));
//   outline-offset:3px;
//   animation:none;
//   overflow:visible;
//   box-shadow:0 4px 12px rgba(var(--hub-glow),.4);
// }

// /* 4) Dashed Border */
// .hub-btn.hub-s4{
//   border-radius:8px !important;
//   border:2px dashed var(--hub-fg) !important;
//   animation:none;
//   box-shadow:0 4px 12px rgba(var(--hub-glow),.4);
// }

// /* 5) Arrow Tag: flat left side, pointed right side */
// .hub-btn.hub-s5{
//   border-radius:0 !important;
//   border:0 !important;
//   border-bottom:4px solid rgba(0,0,0,.35) !important;
//   padding:7px 26px 5px 14px;
//   animation:none;
//   box-shadow:none;
//   clip-path:polygon(0 0, calc(100% - 14px) 0, 100% 50%, calc(100% - 14px) 100%, 0 100%);
// }

// /* 6) Hexagon: pointed on both ends */
// .hub-btn.hub-s6{
//   border-radius:0 !important;
//   border:0 !important;
//   border-bottom:4px solid rgba(0,0,0,.35) !important;
//   padding:7px 26px 5px;
//   animation:none;
//   box-shadow:none;
//   clip-path:polygon(12px 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 12px 100%, 0 50%);
// }

// /* 7) Cut Corner: all four corners cut diagonally */
// .hub-btn.hub-s7{
//   border-radius:0 !important;
//   border:0 !important;
//   border-bottom:4px solid rgba(0,0,0,.35) !important;
//   padding:7px 20px 5px;
//   animation:none;
//   box-shadow:none;
//   clip-path:polygon(9px 0, calc(100% - 9px) 0, 100% 9px, 100% calc(100% - 9px), calc(100% - 9px) 100%, 9px 100%, 0 calc(100% - 9px), 0 9px);
// }

// /* 8) Axis Banner: built only with clip-path.
//       Proportions are taken from the Axis Bank banner (button is 40px
//       high, the cut is about 45% of the height):
//       --cut-h    : height of the cut area
//       --cut-flat : width of the flat top edge of the cut
//       --cut-end  : x position where the slanted edge reaches the bottom
//       The polygon goes clockwise: top-left, top-right, bottom-right,
//       then up along the slanted edge, around the rounded corner,
//       and back to the left edge. */
// .hub-btn.hub-s8{
//   --cut-h:18px;
//   --cut-flat:21px;
//   --cut-end:37px;
//   box-sizing:border-box;
//   position:relative !important;
//   left:auto !important;
//   bottom:auto !important;
//   height:40px;
//   border-radius:0 !important;
//   border:0 !important;
//   padding:0 20px 0 46px;
//   gap:9px;
//   text-transform:uppercase;
//   letter-spacing:1.3px;
//   font-weight:700;
//   animation:none;
//   box-shadow:none !important;
//   clip-path:polygon(
//     0 0,
//     100% 0,
//     100% 100%,
//     var(--cut-end) 100%,
//     calc(var(--cut-flat) + 8px) calc(100% - 14px),
//     calc(var(--cut-flat) + 6px) calc(100% - 15.8px),
//     calc(var(--cut-flat) + 3px) calc(100% - 17.4px),
//     var(--cut-flat) calc(100% - var(--cut-h)),
//     0 calc(100% - var(--cut-h))
//   );
// }
// /* the wrapper is fixed on the screen and draws the glow, because the
//    clip-path of the inner button would clip a normal box-shadow */
// .hub-s8-wrap{
//   position:fixed; left:16px; bottom:18px; z-index:999;
//   display:inline-block; line-height:0;
//   filter:drop-shadow(0 4px 7px rgba(var(--hub-glow),.55));
//   transition:transform .25s ease, filter .25s ease;
// }
// .hub-s8-wrap:hover{
//   transform:translateY(-2px);
//   filter:drop-shadow(0 7px 11px rgba(var(--hub-glow),.75));
// }
// .hub-s8-wrap.hub-preview{ position:relative; left:auto; bottom:auto; }
// .hub-s8-wrap .hub-btn:hover{ transform:none; }

// /* ---------- MOVING BORDER (only for colors with moving:true) ----------
//    Two background layers:
//    1) the normal color gradient, clipped to the padding box (inside)
//    2) a conic gradient, clipped to the border box (the border ring)
//    The conic gradient angle is animated, so a bright light keeps
//    travelling around the border. The light colors come from
//    --hub-t1 / --hub-t2 / --hub-t3 (set per color in the COLORS list). */
// .hub-btn.hub-moving{
//   border:3px solid transparent !important;
//   background:
//     var(--hub-bg) padding-box,
//     conic-gradient(
//       from var(--hub-angle),
//       rgba(255,255,255,.18) 0%,
//       rgba(255,255,255,.18) 50%,
//       var(--hub-t1) 66%,
//       var(--hub-t2) 80%,
//       var(--hub-t3) 90%,
//       var(--hub-t2) 96%,
//       rgba(255,255,255,.18) 100%
//     ) border-box !important;
//   animation:hubSpin 2.4s linear infinite !important;
//   box-shadow:0 0 14px rgba(var(--hub-glow),.6) !important;
// }
// /* keep the button size the same as before (border is 3px now) */
// .hub-btn.hub-moving:not(.hub-s8){
//   padding:5px 18px !important;
// }
// .hub-btn.hub-moving:hover{
//   box-shadow:0 0 22px rgba(var(--hub-glow),.9) !important;
// }
// @keyframes hubSpin{
//   to{ --hub-angle:360deg; }
// }

// /* ---------- MOVING BORDER + AXIS BANNER (#8) ----------
//    The clip-path of .hub-s8 already cuts the body and its moving border
//    at the corner. Only the padding is reduced by the 3px border (the
//    box is border-box, so the height stays 40px), and the box-shadow is
//    removed (the wrapper draws the glow instead). */
// .hub-btn.hub-moving.hub-s8{
//   padding:0 17px 0 43px !important;
//   box-shadow:none !important;
// }

// /* ---------- Preview panel ---------- */
// .hub-preview-wrap{
//   position:fixed; left:0; bottom:12px; z-index:999;
//   display:flex; flex-direction:column; gap:14px;
// //   padding:12px 1px; 
// // background:rgba(255,255,255,.98);
// //   border:1px solid #e5e7eb; 
// // border-radius:12px;
// //   box-shadow:0 8px 30px rgba(0,0,0,.18);
//   max-height:calc(100vh - 24px); 
// //   overflow-y:auto;
// }
// .hub-preview-title{ font-size:11px; font-weight:700; color:#222; text-align:center; }
// .hub-preview-row{ display:flex; align-items:center; justify-content:space-between; gap:16px; }
// .hub-preview-label{ font-size:10px; font-weight:600; color:#555; min-width:150px; }
// .hub-btn.hub-preview{ position:relative; left:auto; bottom:auto; }

// @media (max-width:640px){
//   .hub-btn{ left:10px; bottom:12px; padding:6px 11px; font-size:11px; }
//   .hub-s8-wrap{ left:10px; bottom:12px; }
//   .hub-btn.hub-s8{ height:36px; padding:0 14px 0 44px; font-size:11px; letter-spacing:1px; }
//   .hub-btn.hub-moving.hub-s8{ padding:0 11px 0 41px !important; }
// }
// @media (prefers-reduced-motion:reduce){
//   .hub-btn,.hub-btn::after{ animation:none !important; }
// }
// `;

// /* Small building icon (inline SVG) - used by shapes 1 to 7 */
// const HubIcon = () => (
//   <svg
//     width="14"
//     height="14"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2.2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//     aria-hidden="true"
//   >
//     <path d="M3 21h18" />
//     <path d="M5 21V7l7-4 7 4v14" />
//     <path d="M9 21v-6h6v6" />
//   </svg>
// );

// /* Axis-style triangle mark (two white parallelograms) - used by shape 8 */
// const AxisMark = () => (
//   <svg
//     width="22"
//     height="19"
//     viewBox="712 10 348 300"
//     fill="#ffffff"
//     aria-hidden="true"
//   >
//     <polygon points="883,10 937,100 820,310 712,310" />
//     <polygon points="885,195 990,195 1060,310 945,310" />
//   </svg>
// );

// function HubButton({ color, styleId, preview = false }) {
//   const trail = color.trail || ["#c084fc", "#f472b6", "#ffffff"];
//   const cssVars = {
//     "--hub-bg": color.bg,
//     "--hub-fg": color.fg,
//     "--hub-glow": color.glow,
//     "--hub-t1": trail[0],
//     "--hub-t2": trail[1],
//     "--hub-t3": trail[2],
//   };

//   const link = (
//     <a
//       href={HUB_URL}
//       target="_blank"
//       rel="noopener noreferrer"
//       aria-label={HUB_LABEL}
//       className={`hub-btn hub-s${styleId} ${color.moving ? "hub-moving" : ""} ${
//         preview && styleId !== 8 ? "hub-preview" : ""
//       }`}
//       style={cssVars}
//     >
//       {styleId === 8 ? <AxisMark /> : <HubIcon />}
//       <span>{HUB_LABEL}</span>
//     </a>
//   );

//   // Axis Banner: the wrapper is fixed on screen and draws the glow
//   if (styleId === 8) {
//     return (
//       <span
//         className={`hub-s8-wrap ${preview ? "hub-preview" : ""}`}
//         style={cssVars}
//       >
//         {link}
//       </span>
//     );
//   }

//   return link;
// }

// export default function StickyHubButton() {
//   const color = COLORS.find((c) => c.id === ACTIVE_COLOR) || COLORS[0];
//   const styleId = (STYLES.find((s) => s.id === ACTIVE_STYLE) || STYLES[0]).id;

//   let content;

//   if (PREVIEW_MODE === "designs") {
//     // One row per color + shape pair (every row is different)
//     content = (
//       <div className="hub-preview-wrap">
//         <div className="hub-preview-title"></div>
//         {COLORS.map((c, i) => (
//           <div className="hub-preview-row" key={c.id}>
//             {/* <span className="hub-preview-label">
//               #{c.id} {c.name} / {STYLES[i].name}
//             </span> */}
//             <HubButton color={c} styleId={STYLES[i].id} preview />
//           </div>
//         ))}
//       </div>
//     );
//   } else if (PREVIEW_MODE === "colors") {
//     // All colors with the chosen shape
//     content = (
//       <div className="hub-preview-wrap">
//         <div className="hub-preview-title">Colors (shape #{styleId})</div>
//         {COLORS.map((c) => (
//           <div className="hub-preview-row" key={c.id}>
//             {/* <span className="hub-preview-label">
//               #{c.id} {c.name}
//             </span> */}
//             <HubButton color={c} styleId={styleId} preview />
//           </div>
//         ))}
//       </div>
//     );
//   } else if (PREVIEW_MODE === "styles") {
//     // All shapes with the chosen color
//     content = (
//       <div className="hub-preview-wrap">
//         <div className="hub-preview-title">Shapes (color #{color.id})</div>
//         {STYLES.map((s) => (
//           <div className="hub-preview-row" key={s.id}>
//             {/* <span className="hub-preview-label">
//               #{s.id} {s.name}
//             </span> */}
//             <HubButton color={color} styleId={s.id} preview />
//           </div>
//         ))}
//       </div>
//     );
//   } else {
//     // Production: only the chosen button
//     content = <HubButton color={color} styleId={styleId} />;
//   }

//   return (
//     <>
//       <style>{HUB_CSS}</style>
//       {content}
//     </>
//   );
// }




// new code 




import React from "react";

/* ------------------------------------------------------------------
   Sticky "Axis Business Hub" button
   - Fixed on the RIGHT edge of the screen, vertically centered
   - Arrow Tag shape: flat side on the screen edge, arrow tip pointing LEFT
   - Axis burgundy gradient with the white Axis "A" logo mark
   - Hover: slides left, gradient shifts, glow grows, shine sweeps
   - All CSS is inside this file (no separate .css file needed)
------------------------------------------------------------------- */

// TODO: put the real Axis Business Hub link here
const HUB_URL = "	https://www.axis.bank.in/business-banking/small-business-banking?utm_source=website&utm_medium=assocham-website&cta=assocham";
const HUB_LABEL = "Axis Business Hub";

/* Axis burgundy palette (taken from the Axis Bank banner) */
const PALETTE = {
  deep: "#7a0f3f",
  base: "#97144d",
  bright: "#a3175a",
  light: "#c21f6b",
};

/* Gradient is 200% wide so the hover can slide it across */
const GRADIENT = `linear-gradient(110deg, ${PALETTE.deep} 0%, ${PALETTE.base} 35%, ${PALETTE.bright} 70%, ${PALETTE.light} 100%)`;

/* All CSS lives here. Plain CSS comments only (no // comments). */
const HUB_CSS = `
/* Wrapper: fixed on the right edge and draws the glow.
   A drop-shadow is used because clip-path on the inner link would
   cut away a normal box-shadow. */
.hub-wrap{
  position:fixed;
  right:0;
  top:50%;
  z-index:999;
  display:block;
  line-height:0;
  transform:translateY(-50%);
  filter:drop-shadow(0 4px 8px rgba(151,20,77,.45));
  transition:transform .3s ease, filter .3s ease;
  animation:hubGlow 2.8s ease-in-out infinite;
}
.hub-wrap:hover{
  transform:translateY(-50%) translateX(-6px);
  filter:drop-shadow(0 6px 14px rgba(225,29,116,.75));
  animation:none;
}

/* The button itself: arrow tip on the LEFT, flat edge on the RIGHT */
.hub-link{
  --tip:16px;
  position:relative;
  box-sizing:border-box;
  display:inline-flex !important;
  align-items:center;
  gap:9px;
  height:42px;
  padding:0 18px 0 calc(var(--tip) + 12px);
  margin:0;
  overflow:hidden;
  background:${GRADIENT};
  background-size:200% 100%;
  background-position:0% 50%;
  color:#ffffff !important;
  border:0 !important;
  border-radius:0 !important;
  border-bottom:3px solid rgba(0,0,0,.25) !important;
  font-family:inherit;
  font-size:12px;
  font-weight:700;
  line-height:1;
  letter-spacing:1.2px;
  text-transform:uppercase;
  text-decoration:none !important;
  text-shadow:0 1px 2px rgba(0,0,0,.35);
  white-space:nowrap;
  cursor:pointer;
  transition:background-position .45s ease;
  clip-path:polygon(
    var(--tip) 0,
    100% 0,
    100% 100%,
    var(--tip) 100%,
    0 50%
  );
  top: 230px;
}
.hub-wrap:hover .hub-link{
  background-position:100% 50%;
}

/* Shine sweep: runs only on hover */
.hub-link::after{
  content:"";
  position:absolute;
  top:0;
  left:-60%;
  width:40%;
  height:100%;
  background:linear-gradient(120deg,transparent,rgba(255,255,255,.5),transparent);
  transform:skewX(-20deg);
  pointer-events:none;
}
.hub-wrap:hover .hub-link::after{
  animation:hubShine .8s ease forwards;
}

/* Axis logo lifts a little on hover */
.hub-logo{
  flex-shrink:0;
  transition:transform .3s ease;
}
.hub-wrap:hover .hub-logo{
  transform:translateY(-2px) scale(1.12);
}

@keyframes hubShine{
  0%{ left:-60%; }
  100%{ left:130%; }
}
@keyframes hubGlow{
  0%,100%{ filter:drop-shadow(0 4px 8px rgba(151,20,77,.40)); }
  50%{ filter:drop-shadow(0 4px 14px rgba(225,29,116,.70)); }
}

/* Mobile: slightly smaller */
@media (max-width:640px){
  .hub-link{
    --tip:12px;
    height:36px;
    padding:0 13px 0 calc(var(--tip) + 9px);
    font-size:11px;
    letter-spacing:.9px;
    gap:7px;
  }
}

/* Respect reduced motion */
@media (prefers-reduced-motion:reduce){
  .hub-wrap,
  .hub-link,
  .hub-link::after,
  .hub-logo{
    animation:none !important;
    transition:none !important;
  }
}
`;

/* Axis-style triangle mark (two white parallelograms) */
const AxisMark = () => (
  <svg
    className="hub-logo"
    width="22"
    height="19"
    viewBox="712 10 348 300"
    fill="#ffffff"
    aria-hidden="true"
  >
    <polygon points="883,10 937,100 820,310 712,310" />
    <polygon points="885,195 990,195 1060,310 945,310" />
  </svg>
);

export default function StickyHubButton() {
  return (
    <>
      <style>{HUB_CSS}</style>
      <span className="hub-wrap">
        <a
          className="hub-link"
          href={HUB_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={HUB_LABEL}
          
        >
          <AxisMark />
          <span style={{position: 'relative', left: '-5px'}}>{HUB_LABEL}</span>
        </a>
      </span>
    </>
  );
}